// src/components/Dashboard.js
import React, { useState } from 'react';
import Header from './Header.mjs'; // Seu Header, caso contenha o botão do menu
import MenuHamburguer from './MenuHamburguer.mjs';
import { Outlet } from 'react-router-dom';

const Dashboard = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div style={{ backgroundColor: '#f0e9fd', minHeight: '100vh' }}>
            <Header toggleMenu={() => setIsMenuOpen(!isMenuOpen)} />
            <MenuHamburguer isOpen={isMenuOpen} toggleMenu={() => setIsMenuOpen(false)} />
            <main style={{ padding: '5px' }}>
                <Outlet />
                {/* Conteúdo adicional do Dashboard aqui */}
            </main>
        </div>
    );
};

export default Dashboard;
